import { Pie } from 'vue-chartjs'
import 'chart.piecelabel.js'

export default {
	extends: Pie,
	props: {
		db: {
			type: Object,
			default () {
				return {
					labels: ['型材', '板材', '建材'],
					data: [3, 3, 3,2],
					title: '标题'
				};
			}
		}
	},
	data() {
		return {
			data: {
				labels: this.$props.db.labels,
				datasets: [{
					label: 'Dataset 2',
					backgroundColor: null,
					borderColor: null,
					data: this.$props.db.data,
					borderWidth: 1.5,
					hoverBorderColor: '#fff',
					hoverBackgroundColor: 'rgba(255,255,255,.2)'
				}]
			},
			options: {
				title: {
					display: false,
					text: this.$props.db.title,
					position: "top",
					fontColor: "#fff"
				},
				cutoutPercentage: 50,
				responsive: false,
				maintainAspectRatio: false,
				legend: {
					display: true, //图例
					position: 'right', //位置
					labels: {
						boxWidth: 12, //图例宽度，默认40
						fontColor: "rgba(255,255,255,.5)",
						fontSize:12,
						fontStyle:"bold",
						padding:25
					}
				},
				pieceLabel: {
					render: 'label',
					fontColor: "#fff",
					position: 'outside', //border,outside
					arc: false,
					fontSize: 14,
					fontStyle: 'bold',
				},
				tooltips: {
					enabled: false
				}
			},
		}
	},
	mounted() {
		var fill_gradient_01 = this.$refs.canvas.getContext('2d').createLinearGradient(0, 10, 0, 250),
			fill_gradient_02 = this.$refs.canvas.getContext('2d').createLinearGradient(0, 10, 0, 250),
			fill_gradient_03 = this.$refs.canvas.getContext('2d').createLinearGradient(0, 10, 0, 250),
			fill_gradient_04 = this.$refs.canvas.getContext('2d').createLinearGradient(0, 10, 0, 250),
			fill_gradient_05 = this.$refs.canvas.getContext('2d').createLinearGradient(0, 10, 0, 250),
			border_gradient_01 = this.$refs.canvas.getContext('2d').createLinearGradient(0, 20, 0, 300),
			border_gradient_02 = this.$refs.canvas.getContext('2d').createLinearGradient(0, 20, 0, 300),
			border_gradient_03 = this.$refs.canvas.getContext('2d').createLinearGradient(0, 20, 0, 300),
			border_gradient_04 = this.$refs.canvas.getContext('2d').createLinearGradient(0, 20, 0, 300),
			border_gradient_05 = this.$refs.canvas.getContext('2d').createLinearGradient(0, 20, 0, 300);

		fill_gradient_01.addColorStop(0, 'rgba(131, 255, 70, 0.6)');
		fill_gradient_01.addColorStop(1, 'rgba(131, 255, 70, 0)');

		fill_gradient_02.addColorStop(0, 'rgba(32, 160, 255, 0.6)');
		fill_gradient_02.addColorStop(1, 'rgba(32, 160, 255, 0)');

		fill_gradient_03.addColorStop(0, 'rgba(255, 211, 0, 0.6)');
		fill_gradient_03.addColorStop(1, 'rgba(255, 211, 0, 0)');

		fill_gradient_04.addColorStop(0, 'rgba(255, 75, 164, 0.6)');
		fill_gradient_04.addColorStop(1, 'rgba(255, 75, 164, 0)');

		fill_gradient_05.addColorStop(0, 'rgba(255, 255, 255, 0.4)');
		fill_gradient_05.addColorStop(1, 'rgba(255, 255, 255, 0)');

		border_gradient_01.addColorStop(0, 'rgba(131, 255, 70, 1)');
		border_gradient_01.addColorStop(1, 'rgba(131, 255, 70, 0.4)');

		border_gradient_02.addColorStop(0, 'rgba(32, 160, 255, 1)');
		border_gradient_02.addColorStop(1, 'rgba(32, 160, 255, 0.4)');

		border_gradient_03.addColorStop(0, 'rgba(255, 211, 0, 1)');
		border_gradient_03.addColorStop(1, 'rgba(32, 160, 255, 0.4)');

		border_gradient_04.addColorStop(0, 'rgba(255, 75, 164, 1)');
		border_gradient_04.addColorStop(1, 'rgba(255, 75, 164, 0.5)');

		border_gradient_05.addColorStop(0, 'rgba(255, 255, 255, .8)');
		border_gradient_05.addColorStop(1, 'rgba(255, 255, 255, 0.3)');

		this.data.datasets[0].backgroundColor = [fill_gradient_01, fill_gradient_02,fill_gradient_03, fill_gradient_04,fill_gradient_05,fill_gradient_02,fill_gradient_03, fill_gradient_04,fill_gradient_05];
		this.data.datasets[0].borderColor = [border_gradient_01, border_gradient_02,border_gradient_03, border_gradient_04,border_gradient_05,border_gradient_02,border_gradient_03, border_gradient_04,border_gradient_05];

		this.renderChart(this.data, this.options);
	},
	watch: {
		db: function() {
			this.data.labels = this.$props.db.labels;
			this.data.datasets[0].data = this.$props.db.data;
			this.options.title.text = this.$props.db.title;
			this.$data._chart.update();
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/charts/PieChart.js